import { colorSchemes } from './colorSchemes';
import { twMerge } from 'tailwind-merge';
export var ribbonSchemes = function (scheme) {
    var baseColorScheme = colorSchemes(scheme);
    var finalStyle = '';
    switch (scheme) {
        case 'error':
            finalStyle = "text-well-read";
            break;
        case 'important':
            finalStyle = "text-cognac";
            break;
        case 'success':
            finalStyle = "text-tropical-rain-forest";
            break;
        case 'information':
            finalStyle = "text-matisse";
            break;
        default:
            break;
    }
    return twMerge(baseColorScheme, finalStyle);
};
